import {
  AddressInfoFragment,
  LocationInfoFragment,
  MachineInfoFragment,
  PaymentsFragment,
  SkuInfoFragment,
} from '@/graphql/fragments';

import { gql } from 'graphql-tag';

export const LOCATION = gql`
  ${AddressInfoFragment}
  ${SkuInfoFragment}
  ${MachineInfoFragment}
  ${LocationInfoFragment}
  query location($locationId: String!) {
    location(locationId: $locationId) {
      ...LocationInfo
      machines {
        ...MachineInfo
      }
      skus {
        ...SkuInfo
      }
      address {
        ...AddressInfo
      }
    }
  }
`;

export const LOCATION_PAYMENTS = gql`
  ${PaymentsFragment}
  ${AddressInfoFragment}
  query location($locationId: String!) {
    location(locationId: $locationId) {
      code
      displayTimezone
      externalLender
      name
      timezone
      address {
        ...AddressInfo
      }
      ...Payments
    }
  }
`;
